import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.index-of";
import $ from 'jquery';
import { XMLStr2XMLDoc } from '@/components/TwVideo/CommonFunctions';
import { OCX_XML_Initial, OCX_XML_SetLoginInfo, OCX_XML_SetViewChannelID, OCX_XML_Leave, OCX_XML_FullScreen } from '@/components/TwVideo/OCXCommon';
var promiseContext = null;
var twbBackHandle = {
  InitialComplete: function InitialComplete(state, $xmlDoc) {
    if ($xmlDoc.text().indexOf('Login') !== -1) {
      if (promiseContext) {
        promiseContext.resolve();
        state.statenotifyType = '';
        state.isAction = false;
        promiseContext = null;
      }
    }
  },
  connectstate: function connectstate(state, $xmlDoc) {
    if ($xmlDoc.text().indexOf('success') !== -1) {
      if (promiseContext) {
        promiseContext.resolve();
        state.statenotifyType = '';
        state.isAction = false;
        state.isLogin = true;
        promiseContext = null;
      }
    }
  },
  StartViewChl: function StartViewChl(state, $xmlDoc) {
    if ($xmlDoc.text().indexOf('success') !== -1) {
      if (promiseContext) {
        promiseContext.resolve();
        state.statenotifyType = '';
        state.isAction = false;
        promiseContext = null;
      }
    }
  }
};
var state = {
  isLogin: false,
  // 是否初始化并登陆成功
  OCXPlugin: null,
  // 插件实例
  TimeBarOCX: null,
  // 视屏回放时候的时间条插件
  isAction: false,
  // 是否有正在执行的操作
  statenotifyType: '' // 信息类型
};
var mutations = {
  logout: function logout(state) {
    state.isLogin = false;
    state.OCXPlugin = null;
    state.TimeBarOCX = null;
    state.isAction = false;
    state.statenotifyType = '';
  },
  setOCXPlugin: function setOCXPlugin(state, OCXPlugin) {
    state.OCXPlugin = OCXPlugin;
  },
  setTimeBarOCX: function setTimeBarOCX(state, TimeBarOCX) {
    state.TimeBarOCX = TimeBarOCX;
  },
  setStatenotifyType: function setStatenotifyType(state, statenotifyType) {
    state.statenotifyType = statenotifyType;
  },
  setActionStatus: function setActionStatus(state, isAction) {
    state.isAction = isAction;
  },
  twbBack: function twbBack(state, strXMLFormat) {
    var $xmlDoc = $(XMLStr2XMLDoc(strXMLFormat));
    if ($xmlDoc.find('statenotify')) {
      var statenotifyType = $xmlDoc.find('statenotify').attr('type');
      if (state.statenotifyType === statenotifyType) {
        twbBackHandle[statenotifyType](state, $xmlDoc);
      }
    }
  }
};
var actions = {
  InitialComplete: function InitialComplete(_ref) {
    var commit = _ref.commit,
      state = _ref.state;
    var par = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    commit('setStatenotifyType', 'InitialComplete');
    commit('setActionStatus', true);
    return new Promise(function (resolve, reject) {
      promiseContext = {
        resolve: resolve,
        reject: reject
      };
      var sendXML = '';
      if (!par) {
        sendXML = OCX_XML_Initial('Interactive', 'zh-cn', 'LiveNotify2Js', 'Live');
      } else {
        sendXML = OCX_XML_Initial(par[0], par[1], par[2], par[3]);
      }
      state.OCXPlugin.ExecuteCmd(sendXML, sendXML.length);
    });
  },
  // timeInitialComplete() {
  //
  // },
  connectstate: function connectstate(_ref2) {
    var commit = _ref2.commit,
      state = _ref2.state;
    commit('setStatenotifyType', 'connectstate');
    commit('setActionStatus', true);
    return new Promise(function (resolve, reject) {
      promiseContext = {
        resolve: resolve,
        reject: reject
      };
      var sendXML = OCX_XML_SetLoginInfo('admin', '123456', '192.168.4.206', '6003', '', 123434);
      state.OCXPlugin.ExecuteCmd(sendXML, sendXML.length);
    });
  },
  StartViewChl: function StartViewChl(_ref3, deviceNumber) {
    var commit = _ref3.commit,
      state = _ref3.state;
    commit('setStatenotifyType', 'StartViewChl');
    commit('setActionStatus', true);
    return new Promise(function (resolve, reject) {
      promiseContext = {
        resolve: resolve,
        reject: reject
      };
      var sendXML = OCX_XML_SetViewChannelID(deviceNumber, '通道');
      state.OCXPlugin.ExecuteCmd(sendXML, sendXML.length);
    });
  },
  Leave: function Leave(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state;
    commit('setStatenotifyType', '');
    commit('setActionStatus', true);
    return new Promise(function (resolve) {
      var sendXML = OCX_XML_Leave();
      state.OCXPlugin.ExecuteCmd(sendXML, sendXML.length);
      commit('logout');
      resolve();
    });
  },
  FullScreen: function FullScreen(_ref5) {
    var commit = _ref5.commit,
      state = _ref5.state;
    commit('setStatenotifyType', '');
    commit('setActionStatus', true);
    return new Promise(function (resolve) {
      var sendXML = OCX_XML_FullScreen();
      state.OCXPlugin.ExecuteCmd(sendXML, sendXML.length);
      resolve();
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};